const CONSTANTS= {
  LOCALE: 'lt-LT',
  COMMIT_START: 'LFF:'
}

export default CONSTANTS;